if (!customElements.get("product-form")) {
  class ProductForm extends HTMLElement {
    constructor() {
      super();
      if (this.hasChildNodes()) this.init();
    }

    init() {
      this.form = this.querySelector(".js-product-form");
      if (this.form) {
        this.form.querySelector('[name="id"]').disabled = false;
        this.cartDrawer = document.querySelector("cart-drawer");
        this.submitBtn = this.querySelector('[name="add"]');
        this.section = this.closest('product-card');        

        if (theme.settings.afterAtc !== "no-js") {
          this.form.addEventListener("submit", this.handleSubmit.bind(this));
        }
      }
    }

    /**
     * Handles submission of the product form.
     * @param {object} evt - Event object.
     */
    async handleSubmit(evt) {
      if (evt.target.id === "product-signup_form") return;

      evt.preventDefault();

      const cn_product_page_form_elem = this.querySelector("form");

      if(cn_product_page_form_elem.classList.contains("cn_product_page_ATC_form")){
        // adding event data to google tag and analytics
        gtag('event', 'atlas_product_atc_click');
      }else if(cn_product_page_form_elem.classList.contains("cn_collection_page_ATC_form")){
        // adding event data to google tag and analytics
        gtag('event', 'atlas_coll_atc_click');
      }

      if (this.submitBtn.getAttribute("aria-disabled") === "true") return;

      if (theme.settings.vibrateOnATC && window.navigator.vibrate) {
        window.navigator.vibrate(100);
      }

      this.errorMsg = null;
      this.setErrorMsgState();

      // Disable "Add to Cart" button until submission is complete.
      this.submitBtn.setAttribute("aria-disabled", "true");
      this.submitBtn.classList.add("is-loading");

      if (this.section) {
        this.selectedSize = this.section.querySelector('card-variant-picker fieldset.option-size input[type="radio"]:checked');
        if (this.selectedSize) {            
          this.selectedLabel = this.selectedSize.nextElementSibling;
          if (this.selectedLabel && this.selectedLabel.tagName.toLowerCase() === 'label') {              
              this.selectedLabel.classList.add('is-loading');
          }
        } 
      }

      const formData = new FormData(this.form);
      let sections = "cart-icon-bubble";
      if (this.cartDrawer) {
        sections += `,${this.cartDrawer
          .closest(".shopify-section")
          .id.replace("shopify-section-", "")}`;
      }

      formData.append("sections_url", window.location.pathname);
      formData.append("sections", sections);

      const fetchRequestOpts = {
        method: "POST",
        headers: {
          Accept: "application/javascript",
          "X-Requested-With": "XMLHttpRequest",
        },
        body: formData,
      };

      try {
        const oldCartResponse = await fetch(`${theme.routes.cart}.js`);
        if (!oldCartResponse.ok) throw new Error(oldCartResponse.status);
        const oldCartData = await oldCartResponse.json();

        const response = await fetch(theme.routes.cartAdd, fetchRequestOpts);
        const data = await response.json();
        let error =
          typeof data.description === "string"
            ? data.description
            : data.message;
        if (data.errors && typeof data.errors === "object") {
          error = Object.entries(data.errors).map((item) => item[1].join(", "));
        }

        if (data.status) this.setErrorMsgState(error);

        if (!response.ok) throw new Error(response.status);

        if (theme.settings.afterAtc === "page") {
          // Allow the tick animation to complete
          setTimeout(() => {
            window.location.href = theme.routes.cart;
          }, 300);
        } else {
          // Update cart icon count.
          ProductForm.updateCartIcon(data);

          // If item was added from Quick Add drawer, show "Added to cart" message.
          const quickAddDrawer = this.closest("quick-add-drawer");
          if (quickAddDrawer) quickAddDrawer.addedToCart();

          setTimeout(() => {
            // Update cart drawer contents.
            if (this.cartDrawer) {
              this.cartDrawer.renderContents(
                data,
                !quickAddDrawer && theme.settings.afterAtc === "drawer"
              );
            } else if (window.location.pathname === theme.routes.cart) {
              const cartItems = document.querySelector("cart-items");
              if (cartItems) {
                if (cartItems.dataset.empty === "true") {
                  window.location.reload();
                } else {
                  cartItems.refresh();
                }
              }
            }
          });
        }

        const newCartResponse = await fetch(`${theme.routes.cart}.js`);
        if (!newCartResponse.ok) throw new Error(newCartResponse.status);
        const newCartData = await newCartResponse.json();
        //console.log(newCartData);
        // Automatically add insurance if a non-gift card product is added
        const addedItem = newCartData.items.find(
          (item) => item.variant_id === data.variant_id
        );
        
        if (addedItem && !addedItem.gift_card) {
          const insuranceItem = newCartData.items.find(
            (item) => item.id === 40710165004349
          ); // Replace with actual insurance product ID
          if (!insuranceItem) {
            await this.addInsuranceToCart(); // Add insurance only if it's not already in the cart
          }
        }


        // CN gift_reward_add_remove

        const cn_new_cart_check_free_gift = newCartData.items.filter(
          (item) => item.variant_id === 62711230431602
        )[0];

        var atlas_reward_gift = document.querySelector(".atlas_cart_progress_reward_wrapper.cart_rewards_gift");
        if(atlas_reward_gift != null){
          var atlas_free_gift_id = atlas_reward_gift.getAttribute("data-freegift");
          var atlas_free_gift_min = atlas_reward_gift.getAttribute("data-threshold");

          var atlasFreeItemInCart = newCartData.items.find(item => item.variant_id === Number(atlas_free_gift_id));

          const all_cart_items = document.querySelector("table.cart-items tr[data-variant-id='"+atlas_free_gift_id+"']");

          if(newCartData.original_total_price >= Number(atlas_free_gift_min) ){
            if(cn_new_cart_check_free_gift == undefined){
              await this.addFreeProductToCart(atlas_free_gift_id);
            }else{
              // this.removeItemFromCart(atlas_free_gift_id);
            }
          }else{
            if(cn_new_cart_check_free_gift != undefined){
              await this.removeItemFromCart(atlas_free_gift_id);
            }
          }
        }
        // CN gift_reward_add_remove



        
        let is_enable_free_item = theme.routes.is_enable_free_item;
        let current_currency = Shopify.currency.active; 
        let FREE_PRODUCT_VariantID = parseInt(theme.routes.free_product);
        const MIN_CART_VALUE_FOR_FREE_PRODUCT = `${theme.routes.cartFreeproduct}`;
        const thresholdValue = parseInt(MIN_CART_VALUE_FOR_FREE_PRODUCT.split(":")[1], 10) * 100;
        const otherItemsInCart = newCartData.items.filter(item => item.variant_id !== FREE_PRODUCT_VariantID);  
        // console.log("is_enable_free_item",is_enable_free_item,current_currency);
        if(is_enable_free_item == 'true' && current_currency == 'AUD'){                  
          // console.log("free product",FREE_PRODUCT_VariantID,thresholdValue,otherItemsInCart.length);         
          if (newCartData.total_price >= thresholdValue && otherItemsInCart.length > 0) {
            // console.log("need to check for add");
            const freeNecklaceInCart = newCartData.items.find(item => item.variant_id === 40834811887677);
            //console.log("free_item",freeNecklaceInCart);
            if (!freeNecklaceInCart) {             
              //  console.log("need to add product");
               await this.addFreeProductToCart(); // Add free product only if it's not already in the cart 
            }
            else {
              // console.log("already added in cart");
            }
          }
          else {
             const freeNecklaceInCart = newCartData.items.find(item => item.variant_id === 40834811887677);
             if (freeNecklaceInCart) {             
              //  console.log("need to remove product if already added");
               this.removeItemFromCart(freeNecklaceInCart.key);
            }
             
          }         
          
        } 
        
        
        const itemInOldCart = oldCartData.items.filter(
          (item) => item.variant_id === data.variant_id
        )[0];

        // Check if product was already in the cart
        if (itemInOldCart) {
          this.dispatchEvent(
            new CustomEvent("on:line-item:change", {
              bubbles: true,
              detail: {
                cart: newCartData,
                variantId: data.variant_id,
                oldQuantity: itemInOldCart.quantity,
                newQuantity:
                  itemInOldCart.quantity === data.quantity
                    ? itemInOldCart.quantity
                    : data.quantity,
              },
            })
          );
        } else {
          this.dispatchEvent(
            new CustomEvent("on:cart:add", {
              bubbles: true,
              detail: {
                cart: newCartData,
                variantId: data.variant_id,
              },
            })
          );
        }


      } catch (error) {
        console.log(error); // eslint-disable-line
        this.dispatchEvent(
          new CustomEvent("on:cart:error", {
            bubbles: true,
            detail: {
              error: this.errorMsg.textContent,
            },
          })
        );
      } finally {
        // Re-enable 'Add to Cart' button.
        this.submitBtn.classList.add("is-success");
        this.submitBtn.removeAttribute("aria-disabled");
        this.selectedLabel?.classList.add('is-success');
        
        const sideDrawer = document.querySelector('.sidedrawer');        
        if (sideDrawer && sideDrawer.classList.contains('open')) {
            sideDrawer.classList.remove('open');
            document.body.classList.remove('sidedrawer-open');
        }
        
        setTimeout(() => {
          this.submitBtn.classList.remove("is-loading");
          this.submitBtn.classList.remove("is-success");

          this.selectedLabel?.classList.remove("is-loading");
          this.selectedLabel?.classList.remove("is-success");
          // Get the previous sibling element of selectedLabel
          const previousElement = this.selectedLabel?.previousElementSibling;
          
          if (previousElement) {                 
              if (previousElement && previousElement.type === "radio") {                  
                  previousElement.checked = false;
              }
          }
          
        }, 1400);
      }
    }

    /**
     * Adds the insurance product to the cart.
     */
    async addInsuranceToCart() {
      const formData = new FormData();
      formData.append("id", "40710165004349"); // Replace with actual insurance product ID
      formData.append("quantity", 1);

      const fetchRequestOpts = {
        method: "POST",
        headers: {
          Accept: "application/javascript",
          "X-Requested-With": "XMLHttpRequest",
        },
        body: formData,
      };

      try {
        const response = await fetch("/cart/add.js", fetchRequestOpts);
        if (!response.ok) throw new Error(response.statusText);
        const data = await response.json();
        document.dispatchEvent(
          new CustomEvent("dispatch:cart-drawer:refresh", {
            bubbles: true,
          })
        );
      } catch (error) {
        console.error("Error adding insurance:", error);
      }
    }

    /**
     * Adds the free product to the cart.
     */
    async addFreeProductToCart(FREE_PRODUCT_VariantID = parseInt(theme.routes.free_product)) {
      // let FREE_PRODUCT_VariantID = parseInt(theme.routes.free_product);
      const formData = new FormData();
      formData.append("id", FREE_PRODUCT_VariantID);
      formData.append("quantity", 1);

      const fetchRequestOpts = {
        method: "POST",
        headers: {
          Accept: "application/javascript",
          "X-Requested-With": "XMLHttpRequest",
        },
        body: formData,
      };

      try {
        const response = await fetch("/cart/add.js", fetchRequestOpts);
        if (!response.ok) throw new Error(response.statusText);
        const data = await response.json();
        document.dispatchEvent(
          new CustomEvent("dispatch:cart-drawer:refresh", {
            bubbles: true,
          })
        );
      } catch (error) {
        console.error("Error adding Free Product:", error);
      }
    }

    async removeItemFromCart(itemId) {
      try {
        const removeItemResponse = await fetch('/cart/change.js', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            'Accept': 'application/json'
          },
          body: JSON.stringify({
            id: itemId,
            quantity: 0
          })
        });
        if (!removeItemResponse.ok) throw new Error(removeItemResponse.status);
        const updatedCartData = await removeItemResponse.json();
        //console.log('Free item removed from the cart:', updatedCartData);
        if (window.location.pathname === theme.routes.cart) {
           const cartItems = document.querySelector("cart-items");
              if (cartItems) {
                if (cartItems.dataset.empty === "true") {
                  window.location.reload();
                } else {
                  cartItems.refresh();
                }
              } 
        }
        document.dispatchEvent(new CustomEvent('dispatch:cart-drawer:refresh', {
          bubbles: true
        }));
      } catch (error) {
        console.error('Error removing free item:', error);
      }
    }

    /**
     * Updates the cart icon count in the header.
     * @param {object} response - Response JSON.
     */
    static updateCartIcon(response) {
      const cartIconBubble = document.getElementById("cart-icon-bubble");
      if (cartIconBubble) {
        cartIconBubble.innerHTML = response.sections["cart-icon-bubble"];
      }
    }

    /**
     * Shows/hides an error message.
     * @param {string} [error=false] - Error to show a message for.
     */
    setErrorMsgState(error = false) {
      this.errorMsg = this.errorMsg || this.querySelector(".js-form-error");
      if (!this.errorMsg) return;

      this.errorMsg.hidden = !error;
      if (error) {
        this.errorMsg.innerHTML = "";
        const errorArray = Array.isArray(error) ? error : [error];
        errorArray.forEach((err, index) => {
          if (index > 0) this.errorMsg.insertAdjacentHTML("beforeend", "<br>");
          this.errorMsg.insertAdjacentText("beforeend", err);
        });
      }
    }
  }

  customElements.define("product-form", ProductForm);
}
